import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { INotificationWaveCreated } from "@/types/feed.types";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
import NotificationWaveFollowBtn from "./NotificationWaveFollowBtn";
export default function NotificationWaveCreated(t0) {
  const $ = _c(23);
  const {
    notification
  } = t0;
  const {
    isApp
  } = useDeviceInfo();
  const wave = notification.related_wave;
  const contextWaveId = notification.additional_context.wave_id || undefined;
  const waveId = wave?.id ?? contextWaveId;
  let t1;
  if ($[0] !== isApp || $[1] !== wave?.is_direct_message || $[2] !== wave?.is_dm_wave || $[3] !== waveId) {
    t1 = waveId ? getWaveRoute({
      waveId,
      isDirectMessage: wave?.is_direct_message ?? wave?.is_dm_wave ?? false,
      isApp
    }) : null;
    $[0] = isApp;
    $[1] = wave?.is_direct_message;
    $[2] = wave?.is_dm_wave;
    $[3] = waveId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const invitationHref = t1;
  const waveName = wave?.name ?? waveId ?? "Unknown wave";
  let t2;
  if ($[5] !== wave) {
    t2 = wave && <NotificationWaveFollowBtn wave={wave} size={UserFollowBtnSize.SMALL} />;
    $[5] = wave;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== notification.related_identity) {
    t3 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[7] = notification.related_identity;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="tw-flex tw-items-center tw-gap-x-2">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-text-sm tw-font-normal tw-text-iron-400">invited you to a wave:</span>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== invitationHref || $[14] !== waveName) {
    t6 = invitationHref ? <Link href={invitationHref} className="tw-text-sm tw-font-medium tw-text-primary-400 tw-no-underline hover:tw-text-primary-300">{waveName}</Link> : <span className="tw-text-sm tw-font-medium tw-text-iron-300">{waveName}</span>;
    $[13] = invitationHref;
    $[14] = waveName;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== notification.created_at) {
    t7 = <NotificationTimestamp createdAt={notification.created_at} />;
    $[16] = notification.created_at;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== notification.related_identity || $[19] !== t4 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="tw-w-full"><NotificationHeader author={notification.related_identity} actions={t4}>{t5}{t6}{t7}</NotificationHeader></div>;
    $[18] = notification.related_identity;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}